import { render } from "./RecordCalendar.vue?vue&type=template&id=71bfe716&scoped=true&ts=true"
import script from "./RecordCalendar.vue?vue&type=script&lang=ts"
export * from "./RecordCalendar.vue?vue&type=script&lang=ts"

import "./RecordCalendar.vue?vue&type=style&index=0&id=71bfe716&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bfe716"]])

export default __exports__